import { Box, Typography, IconButton, Grid } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { useSpecialRequestsPagination } from "./hooks/useSpecialRequestsQuery";
import { useScopeOfWork } from "../../context/ScopeOfWorkContext";
import { SpecialRequestCard } from "./SpecialRequestCard";
import { SpecialRequest } from "../../context/scope-of-work.types";
import { QueryState } from "../../../../query-states/GlobalQueryState";
import { colors } from "../../../../../../ui/colors";

export const SpecialRequests = () => {
  const { state, dispatch } = useScopeOfWork();

  const { isLoading, isError, items, page, totalPages, goNextPage, goPrevPage } = useSpecialRequestsPagination();

  const handleToggleRequest = (req: SpecialRequest) => {
    dispatch({
      type: "TOGGLE_SPECIAL_REQUEST",
      payload: req,
    });
  };

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <QueryState isLoading={isLoading} isError={!!isError} serviceName="Special Requests" />

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "var(--fx-surface-base, #FFFFFF)",
        }}
      >
        <IconButton
          onClick={goPrevPage}
          disabled={page === 1}
          sx={{
            color: page === 1 ? colors.gray[300] : colors.orange.base,
            "&:hover": {
              backgroundColor: "rgba(255,120,0,0.08)",
            },
          }}
        >
          <ChevronLeft fontSize="large" />
        </IconButton>

        <Typography fontWeight={700} color={colors.gray[700]}>
          Page {page} / {totalPages}
        </Typography>

        <IconButton
          onClick={goNextPage}
          disabled={page === totalPages}
          sx={{
            color: page === totalPages ? colors.gray[300] : colors.orange.base,
            "&:hover": {
              backgroundColor: "rgba(255,120,0,0.08)",
            },
          }}
        >
          <ChevronRight fontSize="large" />
        </IconButton>
      </Box>

      <Grid container spacing={2} mt={1}>
        {items?.map((req) => {
          const isSelected = state.specialRequests.some((x) => x.uid === req.uid);

          return (
            <Grid item xs={12} sm={6} md={4} lg={3} key={req.uid}>
              <SpecialRequestCard request={req} selected={isSelected} onSelect={() => handleToggleRequest(req)} />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};
